<nav class="navbar navbar-expand-md navbar-dark navbar-white fixed-top headerHeight">
    <div class="row collapse navbar-collapse headerDisplay" id="collapsibleNavbar">
        <img src="./assets/images/tl-215.png" class="logoHeight outline-0 cp col-12 col-sm-12 col-lg-2 col-md-2" alt="Logo">
        
        <label class="ml-auto fs-16 regular col-12 col-sm-12 col-lg-10 col-md-10 text-right"><img class="img-fluid mt-1 cp mr-3" src="./assets/images/user.png">{{brokerName}}</label>
    </div>
</nav>
<div class="boxstyle" [ngClass]="{'hauto': showPaymentNotDone==true}">
    <div *ngIf="showPaymentNotDone" class="row">
        <div class="col-12 col-lg-4 col-md-4 col-sm-12 p-3">
            <div class="whitebox br-6 p-2">
                <div class="border-bottom p-2">
                    <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Quote Details</span>
                </div>
                <div class="p-2" *ngFor="let item of policyInfoData">
                    <label class="lightgray2 regular fs-16 lblmb0">Travel Dates:</label><br>
                    <label class="purple bold fs-16">{{item.effetiveDate | date:'ddMMMyyyy'}} - {{item.expiryDate | date:'ddMMMyyyy'}}</label><br>
                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Travel Days:</label>
                    <p class="purple bold fs-16">{{item.noOfDays}}</p>
                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Purchaser's Province of Residence:</label><br>
                    <label class="purple bold fs-16">{{item.purchaserProvince}}</label><br>
                    <div>
                        <label class="lightgray2 regular fs-16 mt-2 lblmb0" >Number of Insureds:</label><br>
                        <label class="purple bold fs-16">{{item.numberOfInuredes}}</label><br>
                    </div>
                    <label class="lightgray2 regular fs-16 tooltip1 mt-2 lblmb0">DOB:
                        <img src="./assets/images/iIconblue.svg">
                        <div class="tooltiptext1 regular fs-14">
                            <span class="whitespacenormal italic tooltiptext2">DOB is the insured's date of birth.</span>
                        </div>
                    </label>
                    <div class="purple bold fs-16 wordbreakall" *ngFor="let data of item.insuredInfos;let i=index">{{data.insuredFirstName}} {{data.insuredLastName}} - {{data.dateOfBirth | date:'dd MMM yyyy'}}</div>
                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Insured Information:</label>
                    <div *ngFor="let data of item.insuredInfos;let i=index" class="purple bold fs-16 ">{{data.insuredFirstName}} {{data.insuredLastName}} - (Age: {{data.age}})</div>
                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Wait Period:</label>
                    <div *ngFor="let data of item.insuredInfos;let i=index" class="purple bold fs-16 ">{{data.insuredFirstName}} {{data.insuredLastName}} - ({{data.waitPeriod}})</div>
                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Plan Name:</label><br>
                    <label class="purple bold fs-16 cp underline" (click)="planNameClick(item.planName,item.amount);viewPolicyDetailsPopup=!viewPolicyDetailsPopup">{{item.planName}}</label><br>
                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Plan Info:</label><br>
                    <label class="purple bold fs-16 cp underline" (click)="onSelectedBoxFile(0)">View Policy</label><br>
                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Total Amount:</label><br>
                    <label class="purple bold fs-16">{{item.amount}}</label><br>
                </div>
            </div>
            <div class="clear10"></div>
            <div class="whitebox br-6 p-2">
                <ul id="popupbullets" class="ulbulletclass">
                    <li class="desclist">This is not a valid policy until the payment has been successfully processed.</li>
                    <li class="desclist">If you would like to make changes to the summary provided, please contact your broker.</li>
                </ul>
            </div>
        </div>
        <div class="col-12 col-lg-8 col-md-8 col-sm-12 p-3">
            <label class="bold fs-18">PAYMENT INFORMATION</label>
            <div class="regular fs-14 txt-black">Total Amount</div>
            <div>
                <input type="text" class="form-control forminput1 Tab col-sm-3 col-md-3 col-lg-3 col-xl-3 col-11" placeholder="Type here" disabled [(ngModel)]="policyAmount">
            </div>
            <div class="clear10"></div>
            <div class="row">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                    <label class="regular fs-14 txt-black">Card Number<span class="redstar">*</span>&nbsp;<span class="fs-14 regular txt-black">{{cardType}}</span></label>
                    <div>
                        <input type="text" class="form-control forminput1 Tab col-sm-11 col-md-11 col-lg-11 col-xl-11 col-11" placeholder="Type here" [(ngModel)]="cardNoToSend" (input)="cardNoClick();ValidateCreditCardNumber();" maxlength="16">
                        <p class="fs-14 regular redstar" *ngIf="cardNoValid">'Card Number' is not valid.</p>
                        <p class="fs-14 regular redstar" *ngIf="cardError">'Card Number' is not valid.</p>
                    </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                    <label class="regular fs-14 txt-black">Expiry Month<span class="redstar">*</span></label>
                    <div>
                        <ng-select class="col-sm-11 col-md-11 col-lg-11 col-xl-11 col-11" placeholder="Select" [(ngModel)]="expDate1ToSend" (change)="expiryDateClick()">
                            <ng-option disabled value="undefined" selected>Select</ng-option>
                            <ng-option value="01">01-Jan</ng-option>
                            <ng-option value="02">02-Feb</ng-option>
                            <ng-option value="03">03-Mar</ng-option>
                            <ng-option value="04">04-Apr</ng-option>
                            <ng-option value="05">05-May</ng-option>
                            <ng-option value="06">06-Jun</ng-option>
                            <ng-option value="07">07-Jul</ng-option>
                            <ng-option value="08">08-Aug</ng-option>
                            <ng-option value="09">09-Sep</ng-option>
                            <ng-option value="10">10-Oct</ng-option>
                            <ng-option value="11">11-Nov</ng-option>
                            <ng-option value="12">12-Dec</ng-option>
                        </ng-select>
                    </div>
                    <p class="fs-14 regular redstar" *ngIf="expirydateValid">'Expiry Month' is not valid.</p>
                </div>
                <div  class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                    <label class="regular fs-14 txt-black">Expiry Year<span class="redstar">*</span></label>
                    <div>
                        <ng-select class="col-sm-11 col-md-11 col-lg-11 col-xl-11 col-11" placeholder="Select" [(ngModel)]="expDateYearToSend" (change)="expiryYearClick()">
                            <ng-option value="25" selected>2025</ng-option>
                            <ng-option value="26">2026</ng-option>
                            <ng-option value="27">2027</ng-option>
                            <ng-option value="28">2028</ng-option>
                            <ng-option value="29">2029</ng-option>
                            <ng-option value="30">2030</ng-option>
                            <ng-option value="31">2031</ng-option>
                            <ng-option value="32">2032</ng-option>
                            <ng-option value="33">2033</ng-option>
                            <ng-option value="34">2034</ng-option>
                        </ng-select> 
                    </div>
                    <p class="fs-14 regular redstar" *ngIf="expiryyrValid">'Expiry year' is not valid.</p>
                </div>
            </div>
            <div class="clear10"></div>
            <div class="row">
                <div class="col-12 col-lg-5 col-md-5 col-sm-12">
                    <re-captcha (resolved)="resolved($event)" siteKey="6LcRs3crAAAAAIaob4qTZQyYqAQoj24rAy43s2zw"></re-captcha><br>
                </div>
                <div class="col-12 col-lg-5 col-md-5 col-sm-12 text-right textLeft1">
                    <button type="submit" class="payNowBtn ml-1 bold" [ngClass]="{'op5': cardNoValid==true || cardError==true || expirydateValid==true || expiryyrValid==true || checkForCaptcha==false}" [disabled]="cardNoValid==true || cardError==true || expirydateValid==true || expiryyrValid==true || checkForCaptcha==false" (click)="checkPaymentAmount()">Pay Now</button>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showLinkExpiredMessage">
        <div class="clear50"></div>
        <div class="row">
            <div class="col-12 col-lg-12 col-md-12 col-sm-12 text-center">
                <img class="mr-2" src="./assets/images/redexclamation.png">
            </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
            <div class="col-12 col-lg-12 col-md-12 col-sm-12 text-center">
                <label class="lightgray2 regular fs-16 lblmb0">This link is no longer valid. Please contact your broker {{brokerName}} by</label><br>
            </div>
            <div class="col-12 col-lg-12 col-md-12 col-sm-12 text-center">
                <label class="lightgray2 regular fs-16 lblmb0">Email: <span class="bold">{{brokerEmail}}</span> or Phone: <span class="bold">{{brokerPhoneNumber}}</span></label><br>
            </div>

        </div>
    </div>
    <div *ngIf="showPaymentAlreadyDone">
        <div class="clear50"></div>
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                <img class="mb-3" src="./assets/images/successtikMark.png">
                <div class="mb-3">
                    <label class="fs-20 bold">PURCHASE CONFIRMED.</label>
                </div>
                <div class="mb-3">
                    <label class="fs-18 regular">Your policy number is {{policyNumber}}</label>
                </div>
                <div class="">
                    <label class="fs-18 regular">Your confirmation of coverage has been sent to your email:</label>
                </div>
                <div class="mb-2">
                    <label class="fs-18 bold">{{purchaserEmailAddress}}</label>
                </div>
                <div class="mb-3">
                    <button type="button" class="regular gohomeBTN" (click)="clear(); this.printPopup = !this.printPopup">Email to Other Recipients</button>            
                </div>
                <div class="mb-3">
                    <button type="button" class="fs-16 regular cardBoxBlueBorder" (click)="getPolicyDocs()">Download Policy Package<img class="floatRight h22" src="./assets/images/downloadIcon.svg"></button>            
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                <label class="regular fs-16 mb-0 footertext">If you require assistance, please contact your broker or <a href="https://www.travelance.ca/contact-us/" target="_blank">Travelance</a>.</label><br>
            </div>
        </div>
    </div>
</div>
<div id="viewPolicyDetails" class="modal" [style.display]="viewPolicyDetailsPopup ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <span class="fs-16 text46 semi-bold">{{PopupPlanName}}</span>
            <h6 class="close text-right" (click)="viewPolicyDetailsPopup=!viewPolicyDetailsPopup">&times;</h6>
        </div>
        <div class="modal-body">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                <ul id="viewPolicyDetails1" class="posfix">
                    <li class="{{tabs[0].active}}" (click)="openTabs(0)"><a class="active">Description & Summary</a></li>
                    <li class="{{tabs[1].active}}" (click)="openTabs(1)"><a>Eligibility</a></li>
                    <li class="{{tabs[2].active}}" (click)="openTabs(2)"><a>Exclusions</a></li>
                    <li class="{{tabs[3].active}}" (click)="openTabs(3)"><a>Policy Wording</a></li>
                </ul>
            </div>
            <div class="{{tabs[0].tabcontent}}" *ngIf="tabs[0].active">
                <div class="clear50"></div>
                <p class="descPara">The International Student Travel Insurance Policy is an emergency medical insurance plan providing coverage for students, their spouses, and/or their dependents (refer to the ‘Eligibility’ tab). 
                </p>
                <div class="clear20"></div>
                <table class="tabborder w840">
                    <thead >
                        <tr class="text-center">
                            <th class="tabborder">Coverage</th>
                            <th class="tabborder">Maximum Benefit Payable<br>
                                (per insured person per policy period)
                                </th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr>
                            <th class="tabborder">Emergency Medical Insurance</th>
                            
                        </tr>
                        <tr>
                            <td class="tabborder"> Emergency Medical Treatment</td>
                            <td class="tabborder"> $2,000,000</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Drugs or Medications</td>
                            <td class="tabborder"> Up to $10,000 to 30-day supply</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Private Duty Nursing</td>
                            <td class="tabborder"> Up to $15,000</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Professional Medical Services</td>
                            <td class="tabborder"> Up to $600 per practitioner</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Emergency Air Transportation</td>
                            <td class="tabborder"> When pre-approved by Zurich Travel Assist</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Physical Examination</td>
                            <td class="tabborder"> Up to $150 for one visit</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Non-Emergency Treatment</td>
                            <td class="tabborder"> Up to $3,000</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Maternity Benefit</td>
                            <td class="tabborder"> Up to $25,000 for pre-natal care</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Impacted Wisdom Teeth</td>
                            <td class="tabborder"> Up to $150 per tooth</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Dental – (a)</td>
                            <td class="tabborder"> Up to $5,000 for an accident</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Dental – (b)</td>
                            <td class="tabborder"> Up to $600</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Repatriation</td>
                            <td class="tabborder"> Up to $15,000</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Psychiatric and Psychological Care</td>
                            <td class="tabborder"> Up to $10,000 for in-patient care</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Family Transportation</td>
                            <td class="tabborder"> Up to $5,000</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Eye Examination</td>
                            <td class="tabborder"> One visit per 12 month period</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Prescription Glasses, Contact lenses, Hearing Aids</td>
                            <td class="tabborder"> Up to $200</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Tutorial Services</td>
                            <td class="tabborder"> Up to $20/hour, up to $400</td>
                        </tr>
                        <tr>
                            <td class="tabborder"> Accidental Death & Dismemberment</td>
                            <td class="tabborder"> $10,000</td>
                        </tr>
                    </tbody>
                </table>
                <div class="clear20"></div>
                <div class="descPara mb-3">* The above is a summary of coverage. Please refer to the policy for complete benefits, exclusions, limitations, terms and conditions.
                </div>
                <div class="descPara mb-3"> Underwritten by Zurich Insurance Company Ltd (Canadian Branch).</div>
                <div class="clear20"></div>
            </div>
            <div class="{{tabs[1].tabcontent}}" *ngIf="tabs[1].active">
                <div class="clear50"></div>
                <p class="desclist">To be eligible for coverage under this policy, you must, as of the date you apply for coverage and the effective date:</p>
                <ul id="popupbullets" class="ulbulletclass">
                    <li class="desclist">You have not been advised by a physician to avoid travel at this time; and
                    </li>
                    <li class="desclist">You are not travelling against a physician’s advice and you have not been diagnosed with a terminal illness for which a physician has estimated you have less than six (6) months to live; and
                    </li>
                    <li class="desclist">You are 69 years of age and under at the time of application date of the policy; and 
                        <ul id="popupbullets" class="ulbulletclass mt-2">
                            <li class="desclist">You are a student enrolled in a school within Canada; or</li>
                            <li class="desclist">You are an accompanying spouse or dependent child(ren) of the student residing in Canada; and</li>
                        </ul>

                    </li>
                    <li class="desclist">You are not insured under a government health insurance plan.</li>
                </ul>
                <div class="clear20"></div>
                <p class="desclist"> <span class="smallTxt" style="font-weight:bold;">Student </span>means the insured person:</p>
                <ul id="popupbullets" class="ulbulletclass ">
                        <li class="desclist">Whose home country is not Canada and who is residing in Canada on a temporary basis; and
                        </li>
                        <li class="desclist ">Who:
                            <ul id="popupbullets" class="ulbulletclass mt-2">
                                <li class="desclist">Is registered at a school, college, university or other governmentally accredited education institution in Canada and attends classes as a full-time student, as defined by the institution; or</li>
                                <li class="desclist">Remains in Canada for up to one year immediately after completion of studies as described above, and who is working or has applied to work in a field related to those studies completed.</li>
                              
                            </ul>
    
                        </li>
                    </ul>

                    
                    <div class="clear20"></div>
                    <p class="desclist"><span class="smallTxt"  style="font-weight:bold;">Spouse </span>means the person who is legally married to you or the person who has been living with you for a continuous period of at least one (1) year and is publicly represented as your domestic partner.</p>
                    
                    <div class="clear20"></div>
                    <p class="desclist"> <span class="smallTxt" style="font-weight:bold;">Dependent children </span>means your unmarried natural, adopted or step-children who are dependent on you for maintenance and support, or your grandchild(ren), who are travelling with you or joining you during your trip, and who are at least thirty (30) days of age and either (i) under twenty one (21) years of age or (ii) under twenty five (25) years of age and in full-time attendance at a recognized institution of higher learning in Canada. Dependent child(ren) also includes children 21 years of age or over who are permanently mentally or physically challenged and incapable of self-support.</p>
                    <div class="clear20"></div>
                <p class="descPara mb-3">* The above is a summary of coverage. Please refer to the policy for complete benefits, exclusions, limitations, terms and conditions.

                    Underwritten by Zurich Insurance Company Ltd (Canadian Branch). 
                </p>
                <div class="clear20"></div>
            </div>


            
            <div class="{{tabs[2].tabcontent}}" *ngIf="tabs[2].active">
                <h1 class="descTxt mt-3">EMERGENCY MEDICAL INSURANCE EXCLUSIONS</h1>
                <p class="descPara">You must be accurate and complete in your dealings with us at all times. </p>
                <br>
                <p class="descPara"> This policy does not pay for any treatment, services, expenses or benefits caused directly or indirectly as a result of any one or more of the following:</p>
                <div class="clear20"></div>
                <p class="desclist"><span class="smallTxt" style="font-weight:bold;">1: Smart Plan policy: </span>The Smart Plan policy does not cover claims related to pre-existing medical conditions, whether disclosed or not at the time of policy purchase. Benefits are not payable for costs incurred due to any sickness or injury or medical condition, whether or not diagnosed by a physician:</p>
                    <ol type="a" class="olbulletclass" >
                        <li class="desclist p-0">for which you exhibited signs or symptoms; or</li>
                        <li class="desclist p-0">for which you required or received medical consultation; and
                        </li>
                        <li class="desclist p-0">which existed prior to the effective date of your coverage.</li>
                       
                    </ol>
                
                <p class="descPara">It is important and your responsibility to understand how this applies to your coverage. In the event of an accident, injury or sickness, your previous medical history may be reviewed when a claim is made.
                </p>
                <div class="clear20"></div>
                <p class="desclist"><span class="smallTxt" style="font-weight:bold;">2. Smart-Plus Plan policy: </span>We will not pay any expenses relating to any of the following:</p>
               
                        <ul id="popupbullets" class="ulbulletclass " >
                            <li class="desclist p-0">a pre-existing medical condition that is not stable in the ninety (90) days before your effective date; and/or </li>
                            <li class="desclist p-0">your heart condition if, in the ninety (90) days before your effective date, any heart condition has not been stable or you have taken any form of nitroglycerine for the relief of angina pain; and/or</li>
                            <li class="desclist p-0">your lung condition if, in the ninety (90) days before your effective date, any lung condition has not been stable or you required treatment or Prednisone for a lung condition.</li>
                          
                        </ul>
                        <p class="desclist"><span class="smallTxt">3. </span>Covered expenses that exceed the reasonable and customary charges where the medical emergency happens. </p>
                        <p class="desclist"><span class="smallTxt">4. </span>Covered expenses that exceed 80% of the cost we would normally have paid under this policy if you do not, or someone on your behalf does not, contact Zurich Travel Assist at the time of the medical emergency. </p>
                        <p class="desclist"><span class="smallTxt">5. </span>Magnetic resonance imaging (MRI), computerized axial tomography (CAT) scans, sonograms, ultrasounds or biopsies, cardiac catheterization, angioplasty and/or cardiovascular surgery including any associated diagnostic test(s) or charges unless prescribed by the treating physician and approved in advance by Zurich Travel Assist prior to being performed. All surgery must be authorized by Zurich Travel Assist prior to being performed except in extreme circumstances where a request for prior approval would delay surgery needed in a life-threatening medical crisis. </p>
                        <p class="desclist"><span class="smallTxt">6. </span>Any non-emergency, investigative or elective treatment such as cosmetic surgery, chronic care, rehabilitation, or any directly or indirectly related complications.</p>
                        <p class="desclist"><span class="smallTxt">7. </span>The continued treatment of a medical condition when you have already received treatment for that medical condition in your home country.</p>
                        <p class="desclist"><span class="smallTxt">8. </span>A medical condition that meets any of the following criteria:</p>
                        <ul id="popupbullets" class="ulbulletclass" >
                            <li class="desclist p-0">When you knew, or for which it was reasonable to expect before you left your home country, or before the effective date of coverage, that you would need or be required to seek treatment for that medical condition. </li>
                            <li class="desclist p-0">A medical condition for which future investigation or treatment was planned before you left your home country.</li>
                            <li class="desclist p-0">A medical condition that produced symptoms that would have caused an ordinarily prudent person to seek treatment in the ninety (90) days before leaving your home country.</li>
                            <li class="desclist p-0">A medical condition that had caused your physician to advise you not to travel.</li>
                            <li class="desclist p-0">A medical condition that is the result of you not following treatment as prescribed to you, including prescribed medication, treatments and therapy.</li>
                            <li class="desclist p-0">A medical condition which originated while visiting your home country during the policy period or any condition wholly or partly, directly or indirectly, related thereto  </li>
                          
                        </ul>
                        <p class="desclist"><span class="smallTxt">9. </span>A medical emergency resulting from:</p>
                        <ol type="i" class="olbulletclass">
                            <li class="desclist p-0">mountain climbing requiring the use of specialized equipment, including carabineers, crampons, pick axes, anchors, bolts and lead-rope or top-rope anchoring equipment to ascend or descend a mountain; or</li>
                            <li class="desclist p-0">rock-climbing; or
                            </li>
                            <li class="desclist p-0">parachuting, skydiving, hang-gliding or using any other air-supported sporting device; </li>
                            <li class="desclist p-0">participating in a motorized speed contest; or </li>
                            <li class="desclist p-0">your professional participation in a sport, snorkeling or scuba-diving when that sport, snorkeling or scuba-diving is your principal paid occupation. </li>
                           
                        </ol>
                        <p class="desclist"><span class="smallTxt">10. </span>If you specifically purchased this policy to obtain such treatment or services, whether or not it was authorized by a physician.</p>
                        <p class="desclist"><span class="smallTxt">11. </span>Your self-inflicted injuries, unless medical evidence establishes that the injuries are related to a mental health illness.</p>
                        <p class="desclist"><span class="smallTxt">12. </span>Committing, or your direct or indirect attempt to commit, a criminal act. 
                        </p>
                        <p class="desclist"><span class="smallTxt">13. </span>Intoxication, the misuse, abuse, overdose of, or chemical dependence on medication, drugs, alcohol or other intoxicant.</p>

                        <p class="desclist"><span class="smallTxt">14. </span></p>
                    <ol type="a" class="olbulletclass">
                        <li class="desclist p-0">Voluntary termination of your pregnancy or your post-natal care; and/or
                        </li>
                        <li class="desclist p-0">your pregnancy or childbirth or complications thereof when they happen in the nine (9) weeks before or after the expected date of delivery; and/or
                        </li>
                        <li class="desclist p-0">your child born during your policy period, or coverage for such child.
                        </li>
                       
                    </ol>
                    <p class="desclist"><span class="smallTxt">15. </span>For insured children under two (2) years of age, any medical condition related to a birth defect.</p>
                    <p class="desclist"><span class="smallTxt">16. </span>Any benefit that must be authorized or arranged in advance by Zurich Travel Assist when it has given no authorization or made no arrangement for that benefit as per the terms and conditions of this policy (refer to point 4 under EMERGENCY MEDICAL INSURANCE EXCLUSIONS).</p>
                    <p class="desclist"><span class="smallTxt">17. </span>Any medical emergency that occurs or recurs after your attending physician and our medical advisors recommend that you return to your home country following your treatment, and you choose not to.</p>
                    <p class="desclist"><span class="smallTxt">18. </span>Death or injury sustained while piloting an aircraft, learning to pilot an aircraft, or acting as a member of an aircraft crew.</p>
                    <p class="desclist"><span class="smallTxt">19. </span>For policy extensions: any medical condition that first appeared, was diagnosed or treated after the scheduled departure date and prior to the effective date of the insurance extension.</p>
                    <p class="desclist"><span class="smallTxt">20. </span>Any loss or any medical condition you suffer or contract in a specific country, region or city when a Government of Canada Travel Advisory, issued before your effective date or before departing Canada for a trip during the policy period, advises Canadians to avoid all or nonessential travel to that specific country, region or city. In this exclusion, “medical condition” is limited, related or due to the reason for the travel advisory.

                        If the Travel Advisory is issued after your departure date, your coverage under this Emergency Medical Insurance Benefit in that specific country, region or city will be limited to a period of ten (10) days from the date the Travel Advisory was issued, or to a period that is reasonably necessary for you to safely evacuate the country, region or city back to your residence in Canada.</p>
                    <p class="desclist"><span class="smallTxt">21. </span>Any act of terrorism directly or indirectly caused by, resulting from, arising out of, or that is in connection with biological, chemical, nuclear or radioactive means.</p>
                    <p class="desclist"><span class="smallTxt">22. </span>An act of war.</p>
                    <p class="desclist"><span class="smallTxt">23. </span>Loss or repair of or damage to eyeglasses, contact lenses, prosthetic devices, hearing aids.</p>
                    <p class="desclist"><span class="smallTxt">24. </span>Elective treatment or surgery.</p>
                    <p class="desclist"><span class="smallTxt">25. </span>Psychotherapeutic treatment or rehabilitative treatment, psychological, emotional or mental disorders, except as specified under the section EMERGENCY MEDICAL INSURANCE BENEFITS the benefits, psychiatric/psychological.</p>
                    <p class="desclist"><span class="smallTxt">26. </span>A condition arising out of or resulting from Acquired Immune Deficiency Syndrome (“AIDS”) or AIDS Related Complex (“ARC”) if the condition first manifested itself prior to the effective date of coverage or if the condition arose out of Human Immunodeficiency Virus (“HIV”) which had first been diagnosed or that manifested itself prior to the effective date.</p>
                    <p class="desclist"><span class="smallTxt">27. </span>Expenses incurred if other insurance policies, plans or contracts, including any private or provincial automobile insurance, cover the loss. If, however, the loss exceeds the limits of the other policies, plans or contracts if this insurance covers losses or periods not covered by those other policies, plans or contracts, then this Insurance shall apply in excess of all other valid insurance.</p>
                    <div class="clear20"></div>
                <p class="descPara mb-3">* The above is a summary of coverage. Please refer to the policy for complete benefits, exclusions, limitations, terms and conditions.

                    Underwritten by Zurich Insurance Company Ltd (Canadian Branch). 
                </p>
                <div class="clear20"></div>
            </div>
            <div class="{{tabs[3].tabcontent}}" *ngIf="tabs[3].active">
                <div class="clear50"></div>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-xl-12 text-right downloadbtn">
                    <div  class="fs-14 regular btn-blue" (click)="downloadPolicyWording()">Download</div>
                    </div>
                </div>
                <div class="clear10"></div>
                <iframe [src]='UrlBoxPolicy1' height="550px" width="100%" title="Policy Wording"></iframe>
            </div>
        </div>
    </div>
  </div>
  <div id="viewPolicyDetails1" class="modal" [style.display]="viewPolicyDetailsPopup1 ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <h6 class="close text-right" (click)="viewPolicyDetailsPopup1=!viewPolicyDetailsPopup1">&times;</h6>
        </div>
        <div class="modal-body">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                <ul id="viewPolicyDetails1" class="posfix">
                   <li><a class="active">Policy Wording</a></li>
                </ul>
            </div>
           
            <div>
                <div class="clear50"></div>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-xl-12 text-right downloadbtn">
                    <div  class="fs-14 regular btn-blue" (click)="downloadPolicyWording()">Download</div>
                    </div>
                </div>
                <div class="clear10"></div>
                <iframe [src]='UrlBoxPolicy1' height="550px" width="100%" title="Policy Wording"></iframe>
            </div>
        </div>
    </div>
  </div>
  <div id="printPopup" class="modal" [style.display]="printPopup ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <div class="row">
                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-7">
                    <label class="fs-16 text46 bold">Email</label><br>
                </div>
                <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5 text-right">
                    <h6 class="fs-20 bold text-right cp" (click)="clear(); this.printPopup = !this.printPopup">&times;</h6>
                </div>
            </div>
        </div>
        <div class="modal-body">
            <label class="fs-16 text46 regular">Share with</label><br>
            <div>
                <input type="text" class="form-control forminput1 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" placeholder="example@gmail.com" [(ngModel)]="email1" (input)="onRemoveEmailError();emailCheck()">
                <p class="regular redstar" *ngIf="emailErrorFlag">Email is required</p>
                <p class="fs-14 regular redstar" *ngIf="emailNotValid">Email is not valid.</p>
            </div>
            <div class="clear20"></div>
            <div>
                <input type="text" class="form-control forminput1 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" placeholder="example@gmail.com" [(ngModel)]="email2" (input)="emailCheck1()">
                <p class="fs-14 regular redstar" *ngIf="emailNotValid1">Email is not valid.</p>
            </div>
            <div class="clear20"></div>
            <div class="text-right">
                <button type="button" class="fs-14 bold okbtngreen" (click)="onSendEmail()">Send</button>
            </div>
        </div>
    </div>
  </div>